// extracted by mini-css-extract-plugin
export default {"popoverContent":"NftListedEllipsisShadowButton_popoverContent__RWq97"};